import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../css/Mirissa.css";

import { storage } from "../../firebase";
import { ref, getDownloadURL } from "firebase/storage";

function Ella() {

  const [imgHero, setImgHero] = useState("");

  // Top images
  const [ella1, setElla1] = useState("");
  const [ella2, setElla2] = useState("");

  // Extra gallery
  const [ella3, setElla3] = useState("");
  const [ella4, setElla4] = useState("");
  const [ella5, setElla5] = useState("");

  // Activity icons
  const [act1, setAct1] = useState("");
  const [act2, setAct2] = useState("");
  const [act3, setAct3] = useState("");
  const [act4, setAct4] = useState("");
  const [act5, setAct5] = useState("");
  const [act6, setAct6] = useState("");
  const [act7, setAct7] = useState("");
  const [act8, setAct8] = useState("");
  const [act9, setAct9] = useState("");

  // Bottom gallery
  const [ella6, setElla6] = useState("");
  const [ella7, setElla7] = useState("");

  useEffect(() => {

    getDownloadURL(ref(storage, "ella-hero.jpg")).then(setImgHero);

    // TOP GALLERY
    getDownloadURL(ref(storage, "ella1.jpg")).then(setElla1);
    getDownloadURL(ref(storage, "ella2.jpg")).then(setElla2);

    // EXTRA GALLERY
    getDownloadURL(ref(storage, "ella3.jpg")).then(setElla3);
    getDownloadURL(ref(storage, "ella4.jpg")).then(setElla4);
    getDownloadURL(ref(storage, "ella5.jpg")).then(setElla5);

    // ACTIVITY IMAGES
    getDownloadURL(ref(storage, "Adam's peak.png")).then(setAct1);
    getDownloadURL(ref(storage, "Nine arch bridge view.png")).then(setAct2);
    getDownloadURL(ref(storage, "Diyaluma Falls.png")).then(setAct3);

    getDownloadURL(ref(storage, "Ravana falls.png")).then(setAct4);
    getDownloadURL(ref(storage, "Ravana cave.png")).then(setAct5);
    getDownloadURL(ref(storage, "Tea planters.png")).then(setAct6);

    getDownloadURL(ref(storage, "Mountain view ella.png")).then(setAct7);
    getDownloadURL(ref(storage, "Nine Arch Bridge View1.png")).then(setAct8);
    getDownloadURL(ref(storage, "Ella Rock View.png")).then(setAct9);

    // BOTTOM
    getDownloadURL(ref(storage, "ella6.jpg")).then(setElla6);
    getDownloadURL(ref(storage, "ella7.jpg")).then(setElla7);

  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="destination-container">
      {/* HERO SECTION */}
      <section
        className="mirissa-hero"
        style={{ backgroundImage: `url(${imgHero})` }}
        data-aos="fade-down"
      >
        <div className="overlay">
          <h1>Ella</h1>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="mirissa-container">
        {/* LEFT CONTENT */}
        <div className="mirissa-left" data-aos="fade-right">

          <h2>Ella</h2>
          <p>
            For nature lovers, adventure seekers,
            and those looking to unwind amidst breathtaking landscapes.
            Adams peak, nine arch & ravana fall are major attractions.
          </p>

          <p>
            Do you want to include Ella in your itinerary? If so, you've come to the right place.
            We are Ceylon Authentic Tours & Travels, offering the best excursion tours for travellers coming to explore the beautiful Sri Lanka.
            Our tour packages in Ella cover the most beautiful and famous places in the city,
            including hiking, trekking, adventures, and excursions.
          </p>

          <div className="mirissa-gallery">
            <img src={ella1} alt="Ella View" />
            <img src={ella2} alt="Ella Nature" />
          </div>

          <p>
            Sri Lanka is home to many natural treasures and beautiful views and is considered one of the most beautiful islands in the world.
            For all types of visitors, there is much of interest to see and experience here.
            This tour is specially designed for nature lovers and visitors who enjoy exploring.
          </p>

          <h3>Visit Ella in Sri Lanka!</h3>
          <p>
            Ella is a small town in the Uva Province of Sri Lanka, rich and diverse.
            It belongs to the Badulla district, 225 kilometers from Colombo.
            Ella is an important railway station on the railway between Colombo and Badulla.
            The train journey from Kandy to Ella is an indispensable and fantastic experience in Sri Lanka.
            It is generally considered one of the best train journeys in the world.
            It is said that the period from January to March is the best time to visit Ella.
          </p>

          <p>
            Our guide will accompany you on a tour of the city of Ella,
            where you will receive valuable and useful information about this city and country.
          </p>

          <h2>The strengths of our city tour in Ella</h2>

          <p>
            When you are in Ella, there are some places that are "absolutely not to be missed," let's see which places you can visit and enjoy.
            Here are some of the main attractions we cover on this full-day trip:
          </p>

          <h3>Mount Adam's Peak</h3>
          <p>
            Your journey through Ella begins with a hike to Mount Adam's Peak. This is an opportunity to see the valley below in pure air.
            Ella is considered to be one of the places with the highest concentration of oxygen.
            Reaching the top takes about 45 minutes. During the ascent of Adam's Peak,
            you will encounter breath-taking landscapes with tea plantations and the beauty of the local villages.
          </p>

          <h3>The Nine Arches Bridge</h3>
          <p>
            This is a world-famous architectural masterpiece, hidden in the green and lush tea plantations of Ella.
            It is located on the outskirts of the city and is a must-see for anyone who comes to visit it.
            This is a masterfully built bridge that stands proudly in the green landscape of the island.
            Nine Arch is a place you must see during a day in Ella.
          </p>

          <h3>Diyaluma Falls</h3>
          <p>
            Diyaluma Falls is the second highest waterfall in Sri Lanka.
            This is a natural wonder, especially when viewed from above.
            Along the way, there are scattered puddles and ponds where you can even swim.
            The waterfall is located right on the outskirts of the city.
          </p>

          <h3>Ravana's Waterfall</h3>
          <p>
            Ravana's waterfall has become a popular stop for all visitors, including locals and foreign tourists.
            A short swim there will refresh you and prepare you for the next adventure.
            When you travel from Ella to Weligama, you will be greeted by waterfalls.
            The Ravana Falls is one of the places connected to the epic "Ramayana."
          </p>

          <h3>Ella Rock</h3>
          <p>
            If you are ready for a hike, Ella Rock will definitely satisfy you.
            This is a hike of about two hours, from the mountain top you can admire a fantastic panoramic view of the entire city.
          </p>

          <h3>Adventure Park Flying Lava</h3>
          <p>
            This is the perfect place for adventurers. You can participate in many adventure activities.
          </p>

          {/* EXTRA CONTENT FROM SCREENSHOT */}
          <div className="mirissa-extra" data-aos="fade-up">

            <div className="mirissa-top-gallery">
              <img src={ella3} alt="Mirissa View" />
              <img src={ella4} alt="Mirissa Beach" />
              <img src={ella5} alt="Mirissa Beach" />
            </div>

          </div>

          {/* ACTIVITIES SECTION */}
          <div className="mirissa-activities" data-aos="fade-up">

            <details className="activity-box" open>
              <summary>• Nature and Scenic Wonders</summary>

              <p>
                Explore the natural beauty of Ella through its iconic landmarks.
                Begin with a breathtaking hike to Adam’s Peak, enjoy the architectural marvel of the Nine Arches Bridge
                surrounded by lush tea plantations, and take in the grandeur of Diyaluma Falls.
                This part of the tour is perfect for those seeking serene landscapes and unforgettable views.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={act1} alt="Adam's Peak" />
                  <p>Adam's peak</p>
                </div>

                <div className="activity-card">
                  <img src={act2} alt="Nine arch" />
                  <p>Nine arch bridge view</p>
                </div>

                <div className="activity-card">
                  <img src={act3} alt="Diyaluma Falls" />
                  <p>Diyaluma Falls</p>
                </div>
              </div>

            </details>

            <details className="activity-box">
              <summary>• Historical and Cultural Exploration</summary>

              <p>
                Delve into Ella’s cultural and historical significance by visiting Ravana Falls, a site deeply intertwined with the Ramayana epic.
                Learn about its legendary past while enjoying a refreshing swim in its cool waters.
                This segment offers a blend of relaxation and cultural enrichment, giving visitors a deeper connection to Ella's history.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={act4} alt="Ravana falls" />
                  <p>Ravana falls</p>
                </div>

                <div className="activity-card">
                  <img src={act5} alt="Ravana cave" />
                  <p>Ravana cave</p>
                </div>

                <div className="activity-card">
                  <img src={act6} alt="Tea planters" />
                  <p>Tea planters</p>
                </div>
              </div>
            </details>

            <details className="activity-box">
              <summary>• Adventure and Panoramic Views</summary>

              <p>
                For adventure enthusiasts, this segment includes a thrilling hike to Ella Rock for stunning panoramic views
                of the city and a visit to the Adventure Park Flying Lava for adrenaline-packed activities.
                Whether you love hiking or crave adventurous fun, this part promises excitement and unforgettable memories.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={act7} alt="Mountain view" />
                  <p>Mountain view ella</p>
                </div>

                <div className="activity-card">
                  <img src={act8} alt="Nine Arch Bridge View" />
                  <p>Nine Arch Bridge View</p>
                </div>

                <div className="activity-card">
                  <img src={act9} alt="Ella Rock View" />
                  <p>Ella Rock View</p>
                </div>
              </div>
            </details>
          </div>

          <div className="mirissa-parrot-rock" data-aos="fade-up">

            <p>
              For all who love nature, this trip will fulfill your travel dreams.
              This is a rich feast for all nature lovers. Start with Adam mountain, Ella will offer you an unparalleled experience.
              Come on, enjoy the rich knowledge that our guide offers and the spectacular flora and fauna of the city.
              Make sure to breathe in as much fresh air as possible and take as many photos as you can.
              Don't miss this unique beauty.
            </p>

            <p>
              Don't miss this beautiful and unique city! This is about 4 to 5 hour tour.
            </p>

            <div className="parrot-gallery">
              <img src={ella6} alt="Parrot Rock Beach" />
              <img src={ella7} alt="Seafood Dish" />
            </div>

          </div>

        </div>

        {/* RIGHT INQUIRY FORM */}
        <div className="mirissa-form" data-aos="fade-left">
          <h3>Make an Inquiry</h3>

          <form
            onSubmit={(e) => {
              e.preventDefault();

              const name = e.target.name.value;
              const email = e.target.email.value;
              const country = e.target.country.value;
              const code = e.target.code.value;
              const phone = e.target.phone.value;
              const arrival = e.target.arrival.value;
              const departure = e.target.departure.value;
              const interest = e.target.interest.value;
              const vehicle = e.target.vehicle.value;   // ✅ NEW
              const adults = e.target.adults.value;
              const kids = e.target.kids.value;
              const message = e.target.message.value;

              const fullMessage = `
                📌 NEW TOUR BOOKING

                👤 Name: ${name}
                📧 Email: ${email}
                🌍 Country: ${country}
                📞 Phone: ${code} ${phone}
                📅 Arrival: ${arrival}
                📅 Departure: ${departure}
                🎯 Interest: ${interest}
                🚗 Vehicle Preference: ${vehicle}
                👨‍👩‍👧 Adults: ${adults}
                🧒 Kids: ${kids}

                💬 Message: ${message} 
              `;

              // ✅ SEND WHATSAPP
              const whatsappNumber = "94710440430"; // your WhatsApp number
              const whatsappURL =
                "https://wa.me/" + whatsappNumber + "?text=" + encodeURIComponent(fullMessage);

              window.open(whatsappURL, "_blank");

              // ✅ SEND EMAIL
              const mailto =
                "mailto:ceylongracetravels@gmail.com" +
                "?subject=" + encodeURIComponent("New Tour Booking") +
                "&body=" + encodeURIComponent(fullMessage);

              window.location.href = mailto;

              alert("✅ Your Booking is Send!");
            }}
          >
            <input name="name" type="text" placeholder="Name *" />
            <input name="email" type="email" placeholder="Email Address *" />

            <select name="country" required>
              <option value="">Choose Your Country *</option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
              <option value="Botswana">Botswana</option>
              <option value="Brazil">Brazil</option>
              <option value="Brunei">Brunei</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cabo Verde">Cabo Verde</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Central African Republic">Central African Republic</option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
              <option value="Congo, Republic of the">Congo, Republic of the</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Côte d’Ivoire">Côte d’Ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Eswatini">Eswatini</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Greece">Greece</option>
              <option value="Grenada">Grenada</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-Bissau">Guinea-Bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Honduras">Honduras</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran">Iran</option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, North">Korea, North</option>
              <option value="Korea, South">Korea, South</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Laos">Laos</option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libya">Libya</option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia">Micronesia</option>
              <option value="Moldova">Moldova</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar (Burma)">Myanmar (Burma)</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="North Macedonia">North Macedonia</option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Qatar">Qatar</option>
              <option value="Romania">Romania</option>
              <option value="Russia">Russia</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">Sao Tome and Principe</option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Sudan">South Sudan</option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syria">Syria</option>
              <option value="Taiwan">Taiwan</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania">Tanzania</option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-Leste">Timor-Leste</option>
              <option value="Togo">Togo</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Vatican City">Vatican City</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Vietnam">Vietnam</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>

            <div className="phone-row">
              <input name="code" className="code" type="text" placeholder="Code" />
              <input name="phone" className="phone" type="text" placeholder="Phone Number *" />
            </div>

            <label htmlFor="arrival">Arrival Date</label>
            <input name="arrival" type="date" />

            <label htmlFor="departure">Departure Date</label>
            <input name="departure" type="date" />

            <select name="interest">
              <option value="">Choose Your Interest *</option>
              <option value="Eco">Eco</option>
              <option value="Beach">Beach</option>
              <option value="Cultural">Cultural</option>
              <option value="Adventure">Adventure</option>
              <option value="Wild Life">Wild Life</option>
              <option value="Relax and Wellness">Relax and Wellness</option>
              <option value="Honeymoon">Honeymoon</option>
              <option value="Ramayana Trail">Ramayana Trail</option>
              <option value="All in one Trails">All in one Trails</option>
            </select>

            <select name="vehicle">
              <option value="">Select Vehicle Type *</option>
              <option value="Sedan – Toyota Prius (3 Pax)">Sedan – Toyota Prius (3 Pax)</option>
              <option value="Sedan – Toyota Axio (3 Pax)">Sedan – Toyota Axio (3 Pax)</option>
              <option value="Sedan – Honda Grace (3 Pax)">Sedan – Honda Grace (3 Pax)</option>
              <option value="Mini – Suzuki Wagon R (2 Pax)">Mini – Suzuki Wagon R (2 Pax)</option>
              <option value="Mini – Toyota Aqua (2 Pax)">Mini – Toyota Aqua (2 Pax)</option>
              <option value="Van – Suzuki Every (4 Pax)">Van – Suzuki Every (4 Pax)</option>
              <option value="Van – Mini Van (4 Pax)">Van – Mini Van (4 Pax)</option>
              <option value="Van – Toyota Noha (4 Pax)">Van – Toyota Noha (4 Pax)</option>
              <option value="Bus – Mitsubishi Rosa (12 Pax)">Bus – Mitsubishi Rosa (12 Pax)</option>
              <option value="Bus – King Long (12 Pax)">Bus – King Long (12 Pax)</option>
            </select>

            <input name="adults" type="number" placeholder="Adults *" />
            <input name="kids" type="number" placeholder="Kids" />

            <textarea name="message" placeholder="Enter your message"></textarea>

            <button type="submit">SUBMIT</button>
          </form>

        </div>

      </section>

      {/* CTA Section */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-box">
          <div className="cta-left">
            <img src={require("../../assets/hile.png")} className="cta-icon" alt="icon" />
            <div className="cta-text">
              <h2>Ready To Adventure And Enjoy Natural</h2>
              <p>Reach Ceylon Authentic Tours & Travels For A Secure, Luxurious, And Unforgettable Adventure!</p>
            </div>
          </div>

          <img src={require("../../assets/plan.png")} className="cta-plane" alt="plane" />

          <button className="cta-btn">LET’S GET STARTED</button>
        </div>
      </section>
    </div>
  );
}

export default Ella;
